import Grid from '../Grid'
import { styled } from '../../utils/styled'
import type { CSSObject } from '../theme/themeTypes'

export const StyledContainer = styled(Grid)(
  ({ paddingLeft }: any): CSSObject => ({
    display: 'inline-flex',
    alignItems: 'center'
  })
)

export const StyledLabelContainer = styled(Grid)(
  ({ paddingLeft }: any): CSSObject => ({
    display: 'inline-flex',
    paddingLeft,
    alignItems: 'center'
  })
)
